import { eventTracker } from 'app/modules/Segment';
import {
  buildJusfyEventsContext,
  buildJusfyEventsProperties,
} from 'app/modules/Segment/buildJusfyEvent';
import {
  FeatureEnum,
  OwnerEnum,
  TContext,
  TProperties,
} from 'app/modules/Segment/types';

const EVENTS = {
  FIRST_ACCESS_SIGNUP_STARTED: 'first_access_signup_started',
  FIRST_ACCESS_SIGNUP_COMPLETED: 'first_access_signup_completed',
  FIRST_ACCESS_2FA_CODE_SENT: 'first_access_2fa_code_sent',
  FIRST_ACCESS_2FA_CODE_VERIFIED: 'first_access_2fa_code_verified',
} as const;

const firstAccessContext: TContext = buildJusfyEventsContext({
  component: 'first-access-flow',
});

function trackFirstAccessEvent(
  event: string,
  feature: FeatureEnum,
  relevantUserActivity: boolean,
  eventMeaning: string,
  additionalProperties?: Record<string, unknown>,
): void {
  const properties: TProperties = buildJusfyEventsProperties({
    event,
    owner: OwnerEnum.PLATAFORMA,
    feature,
    eventMeaning,
    relevantUserActivity,
    extraProperties: additionalProperties,
  });

  eventTracker.track({
    event,
    properties,
    context: firstAccessContext,
  });
}

export function trackFirstAccessSignupStarted(
  additionalProperties?: Record<string, unknown>,
): void {
  trackFirstAccessEvent(
    EVENTS.FIRST_ACCESS_SIGNUP_STARTED,
    FeatureEnum.ONBOARDING,
    false,
    '[Primeiro acesso] Usuário iniciou o fluxo de primeiro acesso informando o e-mail.',
    additionalProperties,
  );
}

export function trackFirstAccessSignupCompleted(
  additionalProperties?: Record<string, unknown>,
): void {
  trackFirstAccessEvent(
    EVENTS.FIRST_ACCESS_SIGNUP_COMPLETED,
    FeatureEnum.ONBOARDING,
    true,
    '[Primeiro acesso] Usuário concluiu a etapa de confirmação de e-mail e avançou para verificação OTP.',
    additionalProperties,
  );
}

export function trackFirstAccess2faCodeSent(
  additionalProperties?: Record<string, unknown>,
): void {
  trackFirstAccessEvent(
    EVENTS.FIRST_ACCESS_2FA_CODE_SENT,
    FeatureEnum.SIGNIN,
    false,
    '[Primeiro acesso] Código OTP enviado para o e-mail do usuário.',
    additionalProperties,
  );
}

export function trackFirstAccess2faCodeVerified(
  additionalProperties?: Record<string, unknown>,
): void {
  trackFirstAccessEvent(
    EVENTS.FIRST_ACCESS_2FA_CODE_VERIFIED,
    FeatureEnum.SIGNIN,
    true,
    '[Primeiro acesso] Usuário verificou o código OTP com sucesso.',
    additionalProperties,
  );
}

export { EVENTS as FIRST_ACCESS_EVENTS };
